// TOP LEVEL IMPORTS
import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Icon from 'antd/lib/icon';

const ActivityText = ({ text, date }) => (
  <div>
    {text}
    <span style={{ fontSize: 10, display: 'inline-block', color: '#999' }}>{date}</span>
  </div>
);

const Text = ({ children }) => <p style={{ fontSize: 12, marginBottom: 0 }}>{children}</p>;

//------------------------------------------------------------------------------
// AUX FUNCTIONS:
//------------------------------------------------------------------------------
const getTextAndColor = ({
  createdAt, category, userFullName, link,
}) => {
  let date = moment(createdAt).format('dddd MMMM Do @ h:mmA ');
  let linkTo = `/app/clients/${(link && link.id) || ''}`;

  const clientLink = <Link to={linkTo}>{userFullName}</Link>;

  switch (category) {
  case 'newLead':
    return {
      text: <ActivityText text={<Text>New lead: {clientLink}</Text>} date={date} />,
      color: '#fd79a8',
      dot: <Icon type="idcard" style={{ fontSize: '16px', color: '#fd79a8' }} />,
    };
  case 'invoiceUnpaid':
    return {
      text: <ActivityText text={<Text>Invoice marked unpaid for {clientLink}</Text>} date={date} />,
      dot: <Icon type="line-chart" style={{ fontSize: '16px', color: 'orange' }} />,
      color: 'red',
    };
  case 'questionnaireCompleted':
    return {
      text: <ActivityText text={<Text>Questionnaire completed by {clientLink}</Text>} date={date} />,
      color: '#74b9ff',
      dot: <Icon type="schedule" style={{ fontSize: '16px', color: '#74b9ff' }} />,
    };
  case 'contractRemainderSent':
    return {
      text: <ActivityText text={<Text>Contract reminder sent to {clientLink}</Text>} date={date} />,
      dot: <Icon type="mail" style={{ fontSize: '16px', color: '#74b9ff' }} />,
      color: '#74b9ff',
    };
  case 'contractSent':
    return {
      text: <ActivityText text={<Text>Contract sent to {clientLink}</Text>} date={date} />,
      dot: <Icon type="mail" style={{ fontSize: '16px', color: '#74b9ff' }} />,
      // text: <span>{`${date} - contract sent to ${userFullName}`}</span>,
      color: '#74b9ff',
    };
  case 'contractSigned':
    return {
      text: <ActivityText text={<Text>Contract signed by {clientLink}</Text>} date={date} />,
      dot: <Icon type="edit" style={{ fontSize: '16px', color: '#fdcb6e' }} />,
      // text: <span>{`${date} - contract signed by ${userFullName}`}</span>,
      color: '#fdcb6e',
    };
  case 'invoiceSent':
    return {
      text: <ActivityText text={<Text>Invoice sent to {clientLink}</Text>} date={date} />,
      dot: <Icon type="mail" style={{ fontSize: '16px', color: '#74b9ff' }} />,
      color: '#74b9ff',
    };
  case 'invoicePaid':
    return {
      text: <ActivityText text={<Text>Invoice paid by {clientLink}</Text>} date={date} />,
      dot: <Icon type="line-chart" style={{ fontSize: '16px', color: 'green' }} />,
      color: 'green',
    };
  case 'invoiceScheduled':
    return {
      text: <ActivityText text={<Text>Invoice scheduled for {clientLink}</Text>} date={date} />,
      dot: <Icon type="mail" style={{ fontSize: '16px', color: '#74b9ff' }} />,
      color: '#74b9ff',
    };
  default:
    return {
      text: null, // <span>{`oops! error!`}</span>,
      color: null, // 'black',
    };
  }
};

export default getTextAndColor;



// WEBPACK FOOTER //
// ./src/routes/app-home/OrganizationTransactions/getTextAndColor.js